/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

var label = require('./label');
var style = require('./style');

module.exports = {
    ...style,
    ...label,
};
